<template>
  
    <v-content>

        <section class="w3l-inner-page-main">
        <div class="breadcrumb-infhny">
        <div class="container">
            <nav aria-label="breadcrumb">
            <h2 class="hny-title text-center">Welcome</h2>
            <ol class="breadcrumb mb-0">
                <li><router-link :to="{name:'home'}">Home</router-link>
                <span class="fa fa-angle-double-right"></span></li>
                <li class="active">Login</li>
            </ol>
            </nav>
        </div>
        </div>
    </section>


      <!-- /contact-form -->
  <section class="w3l-contact-main">
    <div class="contact-infhny py-5">
      <div class="container py-lg-3">
        <div class="top-map">
          <div class="map-content-9">
            <form action="https://sendmail.w3layouts.com/submitForm" method="post">
              <div class="form-top1">
                <h3 class="hny-title text-center mb-lg-5 mb-4" data-aos="fade-down">Leave us a Message</h3>
                <div class="form-top">

                  <div class="form-top-left" data-aos="fade-up">

                    <input type="text" name="w3lName" id="w3lName" placeholder="Name" required="">

                    <input type="email" name="w3lSender" id="w3lSender" placeholder="Email*" required="">

                    <input type="text" name="w3lSubject" id="w3lName" placeholder="Subject" required="">

                  </div>
                  <div class="form-top-righ" data-aos="fade-up">
                    <textarea name="w3lMessage" id="w3lMessage" placeholder="Message*" required=""></textarea>
                  </div>
                </div>
                <div class="text-center">
                  <button type="submit">Submit Now</button>
                </div>
              </div>
            </form>
          </div>
          <div class="cont-details">
            <div class="cont-top london text-center" data-aos="fade-up">
              <h6><span class="fa fa-map-marker"></span> London Office</h6>
              <p>90 Maryam Springs Suite 260, Courbevoie, London, London</p>
              <p><a href="tel:+342 5897555">+342 5897556</a></p>
              <p><a href="mailto:info@example.com">mail@example.com</a></p>
            </div>
            <div class="cont-top paris text-center" data-aos="fade-up">
              <h6><span class="fa fa-map-marker"></span> Paris Office</h6>
              <p>20 Maryam Springs Suite 260, Courbevoie, Paris, Paris</p>
              <p><a href="tel:+442 5897555">+442 5897555</a></p>
              <p><a href="mailto:info@example.com">mail@example.com</a></p>
            </div>
            <div class="cont-top newyork text-center" data-aos="fade-up">
              <h6><span class="fa fa-map-marker"></span> New York Office</h6>
              <p>80 Maryam Springs Suite 260, Courbevoie, New York, USA</p>
              <p><a href="tel:+242 5897555">+242 5897554</a></p>
              <p><a href="mailto:info@example.com">mail@example.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387193.3059445135!2d-74.25986613799748!3d40.69714941774136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m3!3e3!4m0!4m0!5e0!3m2!1sen!2sin!4v1570181661801!5m2!1sen!2sin"
        allowfullscreen=""></iframe>
    </div>

  </section>
  <!-- //contact-form -->

    </v-content>
  
</template>

<script>
  export default {
    props: {
      source: String,
    },
  }
</script>